module.exports = __webpack_public_path__ + "static/media/product-service.f3e1d49b.svg";